import useCapabilities, { useCanManageCommitteesBool, useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";
import { canManageSectionGovernance } from "./canManageSectionGovernance";

export function useCanManageSectionGovernance(sectionLegacyId?: string | null): {
  canManageGovernance: boolean;
  ready: boolean;
} {
  const isGlobalAdmin = useHasRoles([ROLE.GLOBAL_ADMIN]);
  const hasManageCommitteesCapability = useCanManageCommitteesBool();
  const { loaded, sectionLegacyIds, sectionLegacyIdsLoading } = useCapabilities();

  const ready = loaded && (isGlobalAdmin || !sectionLegacyIdsLoading);

  return {
    canManageGovernance: canManageSectionGovernance({
      isGlobalAdmin,
      assignedSectionLegacyIds: sectionLegacyIds,
      sectionLegacyId,
      hasManageCommitteesCapability
    }),
    ready
  };
}
